import { type PointsSummaryResponse, PointsSummaryResponseSchema } from '@cult/schemas';
import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '../../../lib/api-client';

export const pointsKeys = {
  me: () => ['points', 'me'] as const,
};

export const useMyPoints = () => {
  return useQuery<PointsSummaryResponse>({
    queryKey: pointsKeys.me(),
    queryFn: async () => {
      const raw = await apiFetch<unknown>('/points/me/summary');
      return PointsSummaryResponseSchema.parse(raw);
    },
    staleTime: 120_000,
    refetchInterval: 60_000,
    // Refetch whenever the user returns to the tab so the points count reflects any
    // praises/points earned elsewhere. 'always' overrides staleTime for focus refetches.
    refetchOnWindowFocus: 'always',
  });
};
